module.exports = __webpack_public_path__ + "static/img/icon_arg.0dbe2165.png";